// Interface for file details
export interface FileDetails {
    fileName: string;
    filePath: string;
  }
  
  // Main interface for transaction data
  export interface TransactionRecord {
    tCeTCMDFNumber: string;
    volumeAdjustmentReason: string;
    volumeAdjustmentDate: string;
    submissionDate: string;
    productCategory: string;
    productDetail: string;
    rmCode: string;
    standard: string;
    certifiedWeight: string;
    justificationReason?: string;
  }

  export interface IPostInventory {
    tCeTCMDFNumber: string; // Unique identifier number
    productCategory: string; // Category of the product
    productDetail: string; // Detailed information about the product
    certifiedRmCode: string; // Certified raw material code
    standard: string; // Standard description
    balance: string; // Balance amount
    rmPercentage: string; // Raw material percentage
    volumeAdjustmentReason: string[];
    justificationReason?: string; // Optional justification for volume adjustment
    credentialIdNo?: string; // Optional credential ID for RMDF & GOTS
  }
  export  interface IInventoryStepData {
    inventoryData: IPostInventory; // Product Details section
    documentsData: [],
    filesData: string; // Component Details (Popup)
  }

  export interface IInventoryUpdateRawMaterialData {
    rawMaterialCode: string;
    standard: string;
    volumeAdjustment: string;
    standardDisabled?: boolean;
  }
  // Type alias for an array of transactions
  export type TransactionRecords = TransactionRecord[];

  export const mapApiResponseToTransactionRecord = (apiResponse: any[]): TransactionRecord[] => {
    return apiResponse.map((item) => ({
      // Map API fields to TransactionRecord interface
      tCeTCMDFNumber: item.tcEtcMdfNumber || '',
      volumeAdjustmentReason: item.inventoryType || '', // Using justificationReason as volumeAdjustmentReason
      volumeAdjustmentDate: item.transactionDate || '', // Using transactionDate as volumeAdjustmentDate
      submissionDate: item.ledgerTransactionTimestamp ? item.ledgerTransactionTimestamp.split('T')[0] : '', // Format yyyy-mm-dd
      productCategory: item.productCategory || '',
      productDetail: item.productDetail || '',
      rmCode: item.certifiedRmCode || '', // Using certifiedRmCode as rmCode
      standard: item.standard || '',
      certifiedWeight: item.certifiedWeightBought?.toString() || '', // Convert number to string
      justificationReason: item.justificationReason || '', // Map justificationReason from API
    }));
  };
  